export function formatCsvExport({ headers = [], rows = [] }) {
  return [
    headers.map(escapeCsvCell).join(','),
    ...rows.map((row) =>
      headers.map((header) => escapeCsvCell(row?.[header])).join(','),
    ),
  ].join('\n')
}

export function formatApplicationQuestionCsvHeader(question) {
  return `Q: ${question.label || question.key}`
}

export function downloadCsvExport(csvData, fallbackFilename = 'export.csv') {
  const csvContent = formatCsvExport(csvData)
  const blob = new Blob(['\ufeff', csvContent], {
    type: 'text/csv;charset=utf-8;',
  })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.setAttribute('href', url)
  link.setAttribute('download', csvData.filename || fallbackFilename)
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  setTimeout(() => {
    URL.revokeObjectURL(url)
  }, 100)
}

function escapeCsvCell(value) {
  const cellValue = neutralizeSpreadsheetFormula(
    value == null ? '' : String(value),
  )

  if (
    cellValue.includes(',') ||
    cellValue.includes('"') ||
    cellValue.includes('\n')
  ) {
    return `"${cellValue.replace(/"/g, '""')}"`
  }

  return cellValue
}

function neutralizeSpreadsheetFormula(value) {
  if (/^[=+\-@]/.test(value)) return `'${value}`

  return value
}
